import { convertProductProps } from '@utils/products';
import { useViewedProducts } from '@hook/useViewedProducts';
import { Grid, GridProps } from '@components/Grid';
import { ProductsCarousel } from '@components/ProductsCarousel';
import { ProductCard } from '@components/ProductCard';
import { ProductsFeedSleketon } from '@components/ProductsFeedSleketon';

import { useViewedProductsQuery } from './graphql.v4.generated';

export type ViewedProductsGridProps = Pick<GridProps, 'def' | 'tablet' | 'desktop'>;

interface Props {
  excludeProductIds?: number[],
  maxCount?: number,
  grid?: ViewedProductsGridProps,
  onProductClick?: () => void,
}

export const ViewedProductsContainer: React.FC<Props> = ({
  excludeProductIds,
  maxCount,
  grid,
  onProductClick,
}) => {
  const { viewedProductsIds } = useViewedProducts({ excludeProductIds });

  const { data, error, loading } = useViewedProductsQuery({
    variables: {
      ids: viewedProductsIds,
    },
    context: {
      batch: true,
      v4: true,
    },
    skip: viewedProductsIds.length === 0,
  });

  if (loading || error) {
    return (
      <ProductsFeedSleketon
        count={4}
        grid={grid}
      />
    );
  }

  if (data?.productsByIds) {
    const products = data.productsByIds.slice(0, maxCount).map(convertProductProps);

    if (grid) {
      return (
        <Grid
          container={true}
          spacing={10}
        >
          {products.map((product) => (
            <Grid
              key={product.id}
              {...grid}
            >
              <ProductCard
                {...product}
                type="Product"
                onProductClick={onProductClick}
              />
            </Grid>
          ))}
        </Grid>
      );
    }

    return (
      <ProductsCarousel products={products} />
    );
  }

  return null;
};
